import React, { useState, useEffect, useRef, Fragment } from 'react';
import { DataGridPro, GridToolbarContainer, GridToolbarExport, GridToolbarQuickFilter, GridColumnMenu, useGridApiRef, gridFilteredSortedRowIdsSelector, GRID_CHECKBOX_SELECTION_COL_DEF, gridFilterableColumnLookupSelector, GridFooter } from '@mui/x-data-grid-pro';
import { connect } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import DropdownButton from 'react-bootstrap/DropdownButton';
import Dropdown from 'react-bootstrap/Dropdown';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import { VscFolderActive } from 'react-icons/vsc';
import { FaChevronDown, FaUserFriends, FaClock, FaChartLine, FaMagic, FaCalendarAlt, FaExclamationTriangle } from 'react-icons/fa';
import { ToastContainer, toast } from 'react-toastify';
import { formatShorthand, formatPhone } from '../../common/utils';
import LeadNamesInGrid from '../../containers/Loans/LeadNamesInGrid';
import { ModalCtx } from '../../contexts';
import AddToGroup from '../../components/Modals/AddToGroup';
import AddEvent from '../../components/Modals/AddEvent';
import SendMassTxt from '../../components/Modals/SendMassTxt';
import SendMassEmail from '../../components/Modals/SendMassEmail';
import { singleSelectQuickFilter } from '../../common/utils';
import { update } from '../../common/api';
import NoteInGrid from '../Contacts/NoteInGrid';
import TaskInGrid from '../Contacts/TaskInGrid';
import Toolbar from './toolbar';
import LaunchPhoneBurner from '../../components/Modals/LaunchPhoneBurner';
import TableMetric from '../../containers/Reports/metric';


import "react-toastify/dist/ReactToastify.css";
import '../../containers/Dashboard/dashboard.css';


function useQuery() {
    return new URLSearchParams( useLocation().search );
}

const customColumnMenu = ( props ) => {
    return (
        <GridColumnMenu
            { ...props }
            slots={ {
                columnMenuColumnsItem: null,
                columnMenuPinningItem: null
            } }
        />
    );
}

const Prospects = ( { orgId, aid, uid, user, grids, viewing, canExport, stack, loans, contacts, tasks, notes, lists, status, setDatagridWidth, setDatagridOrder } ) => {
    const [ trx, setTrx ] = useState( 0 );
    const [ vol, setVol ] = useState( 0 );
    const [ rev, setRev ] = useState( 0 );
    const [ stages, setStages ] = useState( [] );
    const [ loading, setLoading ] = useState( true );
    const [ dirty, setDirty ] = useState( false );
    const [ prospects, setProspects ] = useState( [] );
    const [ hasPhoneBurner, setHasPhoneBurner ] = useState( false );
    const [ hasTxting, setHasTxting ] = useState( false );
    const [ gridHeight, setGridHeight ] = useState( 0 );
    const [ containerBuffer, setContainerBuffer ] = useState( 125 );
    const [ cols, setCols ] = useState( [] );
    const [ gridReady, setGridReady ] = useState( false );
    const [ filterModel, setFilterModel ] = useState( { items: [] } );
    const [ q, setQ ] = useState( '' );
    const [ classLogic, setClassLogic ] = useState( '' );
    const [ rowModesModel, setRowModesModel ] = useState( {} );
    const [ usingFilter, setUsingFilter ] = useState( false );
    const [ filterName, setFilterName ] = useState( '' );
    const [ conversionRate, setConversionRate ] = useState( .1 );
    const [ variance, setVariance ] = useState( .025 );
    const [ conversionResults, setConversionResults ] = useState( { prex: {}, funded: {} } );
    const [ conversionView, setConversionView ] = useState( 'preapproval' );
    const [ pipelineMetrics, setPipelineMetrics ] = useState( [
        { label: 'Current Prospects', value: 0, tooltip: 'Current # of Prospects', icon: <FaUserFriends style={{ color: '#ff7a59', marginRight: 8 }} /> },
        { label: 'Avg Time as Prospect', value: 0, tooltip: 'Average number of days prospects have been in this stage', icon: <FaClock style={{ color: '#ff7a59', marginRight: 8 }} /> }
    ] );
    const [ conversionMetrics, setConversionMetrics ] = useState( [
        { label: 'Successful Conversion %', value: 0, tooltip: 'Percentage of prospects that moved to PreQual/PreApproved over the past 180 days', icon: <FaChartLine style={{ color: '#ff7a59', marginRight: 8 }} /> },
        { label: 'Avg Time to Convert', value: 0, tooltip: 'Average time it took to convert successful prospects (past 180 days)', icon: <FaCalendarAlt style={{ color: '#ff7a59', marginRight: 8 }} /> },
        { label: 'Projected Conversions', value: 0, tooltip: `Expected conversion range based on a ${Math.round( conversionRate * 100 )}% historical conversion rate (+/- ${Math.round( variance * 100 )}%)`, icon: <FaMagic style={{ color: '#ff7a59', marginRight: 8 }} /> }
    ] );
    const [ riskMetrics, setRiskMetrics ] = useState( [
        { label: 'Stuck Prospects', value: 'Coming Soon', tooltip: 'Current # of Prospects', icon: <FaExclamationTriangle style={{ color: '#ff7a59', marginRight: 8 }} /> }
    ] );

    const [show, setShow] = useState(false);
    const closeModal = () => setShow(false);
    const openModal = () => setShow(true);
    const [ modal, setModal ] = useState();

    const location = useLocation();

    const query = useQuery();

    const handleColumnWidthChange = async ( { colDef, width } ) => {
        const datagrid = 'prospects';

        let newWidths = {};
        gridRef.current.getAllColumns().forEach( col => {
            if ( ![ '__check__', 'actions' ].includes( col.field ) ) {
                newWidths[col.field] = col.width;
            }
        } );
        setDatagridWidth( { grid: datagrid, values: newWidths, fn: filterName } );
        await update( orgId, aid, uid, 'datagrid-width', uid, {
            grid: datagrid,
            values: newWidths,
            fn: filterName
        } );
    }

    const handleColumnOrderChange = async ( params ) => {
        const datagrid = 'prospects';

        const newOrder = [];
        gridRef.current.getAllColumns().forEach( col => {
            if ( ![ '__check__', 'actions' ].includes( col.field ) ) {
                newOrder.push( col.field );
            }
        } );
        setDatagridOrder( { grid: datagrid, values: newOrder, fn: filterName } );
        await update( orgId, aid, uid, 'datagrid-order', uid, {
            grid: datagrid,
            values: newOrder,
            fn: filterName
        } );
    }

    const formatName = ( cid ) => {
        const r = contacts[cid]; // cl.find( f => f.cid === cid );
        return ( r ) ? `${r.firstname} ${r.lastname}` : null;
    };

    const gridHelpers = {
        valueGetter: {
            borrowers: ( { row } ) => {
                let v = [];
                if ( row.borrowers ) {
                    row.borrowers.forEach( b => {
                        const bor = contacts[b.cid];
                        if ( bor ) {
                            v.push( bor.name );
                        }
                    } );
                }
                return v.join( ', ' );
            },
            cobo: ( { row } ) => {
                let v = [];
                if ( row.borrowers ) {
                    row.borrowers.forEach( b => {
                        const bor = contacts[b.cid];
                        if ( bor && bor.firstnamePartner1 ) {
                            v.push( `${bor.firstnamePartner1} ${bor.lastnamePartner1}` );
                        }
                    } );
                }
                return v.join( ', ' );
            },
            phoneBorr: ( { row } ) => {
                let p;  
                if ( row.borrowers ) {
                    const cid = row.borrowers[0].cid;
                    const c = contacts[cid];
                    if ( c && c.phoneMobile && c.phoneMobile.length ) {
                        p = c.phoneMobile;
                    } else if ( c && c.phone && c.phone.length ) {
                        p = c.phone;
                    }
                }
                return ( p ) ? formatPhone( p ) : null;
            },
            phoneCoBo: ( { row } ) => {
                let p;  
                if ( row.borrowers ) {
                    const cid = row.borrowers[0].cid;
                    const c = contacts[cid];
                    if ( c && c.phonePartner1 && c.phonePartner1.length ) {
                        p = c.phonePartner1;
                    }
                }
                return ( p ) ? formatPhone( p ) : null;
            },
            phoneBA: ( { row } ) => {
                let p;  
                if ( row.baId ) {
                    const c = contacts[row.baId];
                    if ( c && c.phoneMobile && c.phoneMobile.length ) {
                        p = c.phoneMobile;
                    } else if ( c && c.phone && c.phone.length ) {
                        p = c.phone;
                    }
                }
                return ( p ) ? formatPhone( p ) : null;
            },
            phoneLA: ( { row } ) => {
                let p;  
                if ( row.laId ) {
                    const c = contacts[row.laId];
                    if ( c && c.phoneMobile && c.phoneMobile.length ) {
                        p = c.phoneMobile;
                    } else if ( c && c.phone && c.phone.length ) {
                        p = c.phone;
                    }
                }
                return ( p ) ? formatPhone( p ) : null;
            },
            emailBorr: ( { row } ) => {
                let e;
                if ( row.borrowers ) {
                    const cid = row.borrowers[0].cid;
                    const c = contacts[cid];
                    if ( c && c.email && c.email.length ) {
                        e = c.email;
                    }
                }
                return ( e ) ? e : null;
            },
            emailCoBo: ( { row } ) => {
                let e;
                if ( row.borrowers ) {
                    const cid = row.borrowers[0].cid;
                    const c = contacts[cid];
                    if ( c && c.emailPartner1 && c.emailPartner1.length ) {
                        e = c.emailPartner1;
                    }
                }
                return ( e ) ? e : null;
            },
            emailBA: ( { row } ) => {
                let e;
                if ( row.baId ) {
                    const c = contacts[row.baId];
                    if ( c && c.email && c.email.length ) {
                        e = c.email;
                    }
                }
                return ( e ) ? e : null;
            },
            emailLA: ( { row } ) => {
                let e;
                if ( row.baId ) {
                    const c = contacts[row.baId];
                    if ( c && c.email && c.email.length ) {
                        e = c.email;
                    }
                }
                return ( e ) ? e : null;
            },
            ooeBorr: ( { row } ) => {
                let oo = false;
                if ( row.borrowers ) {
                    const c = contacts[row.borrowers[0].cid];
                    if ( c && c.optoutEmail ) {
                        oo = c.optoutEmail;
                    }
                }
                return ( oo );
            },
            oocBorr: ( { row } ) => {
                let oo = false;
                if ( row.borrowers ) {
                    const c = contacts[row.borrowers[0].cid];
                    if ( c && c.optoutCall ) {
                        oo = c.optoutCall;
                    }
                }
                return ( oo );
            },
            oosBorr: ( { row } ) => {
                let oo = false;
                if ( row.borrowers ) {
                    const c = contacts[row.borrowers[0].cid];
                    if ( c && c.optoutSms ) {
                        oo = c.optoutSms;
                    }
                }
                return ( oo );
            },
            date: ( { value } ) => {
                let d;
                if ( value ) {
                    d = new Date( value );
                    if ( !value.match( 'T' ) ) {
                        d.setDate( d.getDate() + 1 );
                    }
                }
                return ( d ) ? d : null;
            },
            referral: ( { row } ) => {
                let n;
                if ( row.referredById ) {
                    n = formatName( row.referredById );
                }
                return n;
            },
            salesRep: ( { row } ) => {
                let n;
                if ( row.borrowers ) {
                    const c = contacts[row.borrowers[0].cid];
                    if ( c ) {
                        n = c.salesRepId;
                    }
                }
                return n;
            },
            latestClosedTask: ( { row } ) => {
                return row.lastTask;
            },
            latestNote: ( { row } ) => {
                return row.lastNote;
            }
        },
        renderCell: {
            loanname: ( params ) => <Link to={`/loan/${params.row.id}`}>{params.value}</Link>,
            borrowers: ( { row } ) => <LeadNamesInGrid row={row} />,
            cobo: ( { value } ) => {
                return ( value ) ? value : null;
            },
            phone: ( { value } ) => {
                return ( value ) ? <a href={`tel:${value}`}>{value}</a> : null;
            },
            email: ( { value } ) => {
                return ( value ) ? <a href={`mailto:${value}`}>{value}</a> : null;
            },
            date: ( { value } ) => {
                let d;
                if ( value ) {
                    d = value.toLocaleDateString();
                }
                return d;
            },
            contact: ( { value } ) => {
                let l;
                if ( value ) {
                    const c = contacts[value];
                    if ( c ) {
                        l = <Link to={`/contact/${c.cid}`}>{ formatName( c.cid ) }</Link>
                    }
                }
                return l;
            },
            referral: ( { row } ) => {
                let l;
                if ( row.referredById ) {
                    l = <Link to={`/contact/${row.referredById}`}>{ formatName( row.referredById ) }</Link>
                }
                return l;
            },
            fileNum: ( { row } ) => {
                return ( row.lid && row.fileNum ) ? <Link to={`/loan/${row.lid}`}>{row.fileNum}</Link> : null;
            },
            latestClosedTask: ( { value } ) => {
                return <TaskInGrid task={value} />;
            },
            latestNote: ( { value } ) => {
                return <NoteInGrid note={value} />;
            }
        },
        valueFormatter: {
            phone: ( { value } ) => {
                return ( value ) ? value : null;
            },
            email: ( { value } ) => {
                return ( value ) ? value : null;
            },
            date: ( { value } ) => {
                return ( value ) ? value.toLocaleDateString() : null;
            },
            contact: ( { value } ) => {
                let n;
                if ( value ) {
                    const c = contacts[value];
                    if ( c ) {
                        n = formatName( c.cid );
                    }
                }
                return n;
            },
            referral: ( { value } ) => {
                return ( value ) ? value : '';
            },
            latestClosedTask: ( { value } ) => {
                return ( value && value.name ) ? value.name : null;
            },
            latestNote: ( { value } ) => {
                return ( value && value.name ) ? value.name : null;
            }
        },
        getApplyQuickFilterFn: {
            singleSelectQuickFilter: singleSelectQuickFilter
        }
    };
    
    const containerRef = useRef();
    const titleRef = useRef();
    const numbersRef = useRef();

    const gridRef = useGridApiRef();

    const updateKPIs = ( model, details ) => {
        const visibleRows = gridFilteredSortedRowIdsSelector( gridRef );
        const rows = prospects.filter( d => visibleRows.includes( d.loid ) );
        setTrx( rows.length );

        let v = 0;
        let rev = 0;
        rows.forEach( r => {
            if ( r.paMaxPurchPrice ) {
                let amt = r.paMaxPurchPrice;
                if ( typeof( amt ) === 'string' ) {
                    amt = amt.replace( '$', '' );
                    amt = amt.replace( /,/g, '' );
                    amt = amt.replace( /\.\d\d/, '' );
                    amt = Number( amt );
                }
                v += amt;
            }
            if ( r.revenue ) {
                let amt = r.revenue;
                if ( typeof( amt ) === 'string' ) {
                    amt = amt.replace( '$', '' );
                    amt = amt.replace( /,/g, '' );
                    amt = amt.replace( /\.\d\d/, '' );
                    amt = Number( amt );
                }
                rev += amt;
            }
        } );
        setVol( v );
        setRev( rev );
    }

    const [ selectedRows, setSelectedRows ] = useState( [] );
    
    const handleModal = async ( t ) => {
        let shouldOpen = true;

        const allLids = [];
        const emailLids = [];
        const phoneLids = [];
        const uniqueEmails = new Set();
        const uniquePhones = new Set();
        selectedRows.forEach( lid => {
            const l = loans[lid];
            if ( l.borrowers?.length ) {
                let seenEmails = false;
                let seenPhones = false;
                        
                allLids.push( lid );
                                        
                for ( const b of l.borrowers ) {
                    const c = contacts[b.cid];
                    if ( c ) {
                        if ( c.email && ( uniqueEmails.has( c.email.toLowerCase() ) || c.optoutEmail ) ) {
                            seenEmails = true;
                        }
                        let p = c.phoneMobile || c.phone || c.phoneWork || c.phoneHome;
                        if ( p && ( uniquePhones.has( formatPhone( p  ) ) || c.optoutSms ) ) {
                            seenPhones = true;
                        }
                    }
                }
                        
                if ( !seenEmails ) {
                    emailLids.push( lid );
                }
                if ( !seenPhones ) {
                    phoneLids.push( lid );
                }
            }
        } );
        
        switch ( t ) {
            case 'email-mass':
                setModal( <SendMassEmail close={closeModal} llist={emailLids} objType='loan' aid={viewing[0]} /> );
                break;

            case 'sms-mass':
                setModal( <SendMassTxt close={closeModal} llist={phoneLids} objType='loan' /> );
                break;

            case 'list':
                setModal( <AddToGroup close={closeModal} itemType='loans' items={allLids} aid={viewing[0]} /> );
                break;
    
            // case 'event':
            //     setModal( <AddEvent close={closeModal} contacts={contacts} /> );
            //     break;

            case 'phoneburner':
                setModal( <LaunchPhoneBurner close={closeModal} type='loans' data={allLids} /> );
                break;

            default:
                shouldOpen = false;
                console.log( 'Unknown modal type: ' + t );
        }

        if ( shouldOpen ) {
            openModal();
        }
    }

    const getRowClassName = ( params ) => {
        let cn = '';
        // console.log( classLogic );
        if ( classLogic ) {
            eval( classLogic );
        }
        return cn;
    }

    useEffect( () => {
        console.log( 'setting page title' );
        document.title = 'Third Floor - Prospects';
    }, [] );
    
    useEffect( () => {
        console.log( 'prepping grid columns' );
        let filters = {};
        for ( let [ key, value ] of query.entries() ) {
            filters[key] = value;
        }

        if ( grids && grids.prospects && !gridReady ) {
            let activeFilter = false;
            setFilterName( '' );

            let storedCols = JSON.parse( grids.prospects.cols );
            if ( filters.fn && grids.prospects.filters && grids.prospects.filters[filters.fn] ) {
                if ( grids.prospects.filters[filters.fn].cols ) {
                    activeFilter = true;
                    setUsingFilter( true );
                    setFilterName( filters.fn );
                    storedCols = JSON.parse( grids.prospects.filters[filters.fn].cols );
                }

                if ( grids.prospects.filters[filters.fn].criteria ) {
                    const crit = JSON.parse( grids.prospects.filters[filters.fn].criteria );
                    setFilterModel( { items: crit } );
                }

                if ( grids.prospects.filters[filters.fn].className ) {
                    setClassLogic( grids.prospects.filters[filters.fn].className );
                }
            } else {
                if ( filters.crit ) {
                    const crit = JSON.parse( filters.crit );
                    setFilterModel( { items: crit } );
                }
                if ( grids.prospects.className ) {
                    setClassLogic( grids.prospects.className );
                }
            }

            if ( storedCols ) {
                let cols = storedCols.map( c => {
                    if ( c.renderCell && gridHelpers.renderCell[c.renderCell] ) {
                        c.renderCell = gridHelpers.renderCell[c.renderCell];
                    }
                    if ( c.valueGetter && gridHelpers.valueGetter[c.valueGetter] ) {
                        c.valueGetter = gridHelpers.valueGetter[c.valueGetter];
                    }
                    if ( c.valueFormatter && gridHelpers.valueFormatter[c.valueFormatter] ) {
                        c.valueFormatter = gridHelpers.valueFormatter[c.valueFormatter];
                    }
                    if ( c.getApplyQuickFilterFn && gridHelpers.getApplyQuickFilterFn[c.getApplyQuickFilterFn] ) {
                        c.getApplyQuickFilterFn = gridHelpers.getApplyQuickFilterFn[c.getApplyQuickFilterFn];
                    }
                    
                    if ( user && user.datagrids && user.datagrids.prospects ) {
                        if ( activeFilter ) {
                            if ( user.datagrids.prospects.filters && user.datagrids.prospects.filters[filters.fn] && user.datagrids.prospects.filters[filters.fn].colSize && user.datagrids.prospects.filters[filters.fn].colSize[c.field] ) {
                                c.width = user.datagrids.prospects.filters[filters.fn].colSize[c.field];
                            }
                        } else if ( user.datagrids.prospects.colSize && user.datagrids.prospects.colSize[c.field] ) {
                            c.width = user.datagrids.prospects.colSize[c.field];
                        }
                    }
                    // c.editable = true;
                    return c;
                } );

                if ( user && user.datagrids && user.datagrids.prospects ) {
                    if ( activeFilter ) {
                        if ( user.datagrids.prospects.filters && user.datagrids.prospects.filters[filters.fn] && user.datagrids.prospects.filters[filters.fn].colOrder && user.datagrids.prospects.filters[filters.fn].colOrder.length ) {
                            cols = user.datagrids.prospects.filters[filters.fn].colOrder.map( field => {
                                return storedCols.find( f => f.field === field );
                            } );
                        }
                    } else {
                        if ( user.datagrids.prospects.colOrder && user.datagrids.prospects.colOrder.length ) {
                            cols = user.datagrids.prospects.colOrder.map( field => {
                                return storedCols.find( f => f.field === field );
                            } );
                        }
                    }
                }

                setCols( cols );
                setGridReady( true );
            }
        }

        console.log( 'done prepping grid columns' );
    }, [ user, query, grids, gridHelpers.renderCell, gridHelpers.valueGetter, gridHelpers.valueFormatter, gridHelpers.getApplyQuickFilterFn, gridReady ] );
    
    useEffect( () => {
        console.log( 'adjusting for multiple accounts' );
        if ( user.additionalAccounts && user.additionalAccounts.length > 1 ) {
            setContainerBuffer( prev => prev + 30 );
        }
    }, [ user.additionalAccounts ] );

    useEffect( () => {
        console.log( 'setting container height' );
        const cr = containerRef?.current?.clientHeight || 0;
        const tr = titleRef?.current?.clientHeight || 0;
        const nr = numbersRef?.current?.clientHeight || 0;
        setGridHeight( cr - tr - nr - 15 );
    }, [ containerBuffer ] );

    useEffect( () => {
        if ( loans ) {
            const stats = status.filter( s => s.queue === 'prospect' ).map( m => m.value );
            let list = [];
            Object.keys( loans ).forEach( lid => {
                const l = loans[lid];
                if ( !viewing.includes( l.aid ) ) {
                    return;
                }
                if ( stats.includes( l.status ) && l.borrowers?.length ) {
                    const pri = l.borrowers.find( b => b.label === 'Primary' ) || l.borrowers[0];
                    const c = contacts[pri?.cid];
                    if ( c ) {
                        list.push( {
                            ...l,
                            loanSource: ( l ) ? l.source : null,
                            referredById: c.referredById,
                            rank: c.rank
                        } );
                    }
                }
            } );
            
            list.sort( ( a, b ) => {
                let ad = new Date( a.prospectDate || a.createdDate );
                let bd = new Date( b.prospectDate || b.createdDate );
                return bd.getTime() - ad.getTime();
            } );

            setProspects( list );
            setLoading( false );
            setDirty( true );
        }
    }, [ status, loans, contacts, viewing ] );

    useEffect( () => {
        if ( !dirty ) {
            return;
        }

        const noteBucket = [];
        const taskBucket = [];
        const list = [];

        Object.keys( notes ).forEach( nid => {
            const n = notes[nid];
            if ( viewing.includes( n.aid ) ) {
                noteBucket.push( n );
            }
        } );
        Object.keys( tasks ).forEach( tid => {
            const t = tasks[tid];
            if ( viewing.includes( t.aid ) ) {
                taskBucket.push( t );
            }
        } );

        for ( const l of prospects ) {
            const pri = l.borrowers.find( b => b.label === 'Primary' ) || l.borrowers[0];
            const c = contacts[pri?.cid];
            if ( c ) {
                const tmpNotes = [];
                const tmpTasks = [];

                for ( const n of noteBucket ) {
                    const yes = n.assoc?.find( f => f.cid === c.cid || f.lid === l.lid );
                    if ( yes ) {
                        tmpNotes.push( n );
                    }
                }
                tmpNotes.sort( ( a, b ) => {
                    const ad = new Date( a.createdDate );
                    const bd = new Date( b.createdDate );
                    return bd.getTime() - ad.getTime();
                } );

                for ( const t of taskBucket ) {
                    if ( t.status !== 'Completed' ) {
                        continue;
                    }
                    const yes = t.assoc?.find( f => f.cid === c.cid || f.lid === l.lid );
                    if ( yes ) {
                        tmpTasks.push( t );
                    }
                }
                tmpTasks.sort( ( a, b ) => {
                    const ad = new Date( a.completedDate || a.createdDate );
                    const bd = new Date( b.completedDate || b.createdDate );
                    return bd.getTime() - ad.getTime();
                } );

                list.push( {
                    ...c,
                    ...l,
                    lastTask: tmpTasks[0],
                    lastNote: tmpNotes[0],
                } );
            }
        }
        setProspects( list );
        setDirty( false );
    }, [ dirty, prospects, contacts, notes, tasks, viewing ] );

    useEffect( () => {
        console.log( 'setting metrics...' );
        if ( prospects.length > 0 ) {
            const today = new Date();
            const dayInMilli = 1000 * 60 * 60 * 24;
            
            let totalDays = 0;
            prospects.forEach( prospect => {
                const prospectDate = new Date( prospect.prospectDate || prospect.statusChangeDate || prospect.createdDate );
                totalDays += ( today.getTime() - prospectDate.getTime() ) / dayInMilli;
            } );
            const avgDaysAsProspect = ( totalDays / prospects.length ).toFixed( 1 );

            let window = 180;
            let metrics;
            let nextStage;
            if ( conversionView === 'preapproval' ) {
                metrics = conversionResults.prex[window];
                nextStage = 'PQ/PA';
            } else {
                metrics = conversionResults.funded[window];
                nextStage = 'Funded';
            }
            const projectedMin = Math.round( prospects.length * ( metrics.rate - variance ) );
            const projectedMax = Math.round( prospects.length * ( metrics.rate + variance ) );
            const projectedConversions = `${projectedMin}-${projectedMax}`;
            
            // Calculate stuck prospects (prospects that have been in stage for more than 30 days)
            const stuckProspects = prospects.filter( prospect => {
                const prospectDate = new Date( prospect.prospectDate || prospect.statusChangeDate || prospect.createdDate );
                const daysInStage = ( today.getTime() - prospectDate.getTime() ) / ( 1000 * 60 * 60 * 24 );
                return daysInStage > 30;
            } ).length;

            setPipelineMetrics( [
                { label: 'Current Prospects', value: prospects.length, tooltip: 'Current # of Prospects', icon: <FaUserFriends style={{ color: '#ff7a59', marginRight: 8 }} /> },
                { label: 'Avg Time as Prospect', value: avgDaysAsProspect + ' days', tooltip: 'Average number of days prospects have been in this stage', icon: <FaClock style={{ color: '#ff7a59', marginRight: 8 }} /> }
            ] );
            setConversionMetrics( [
                { label: `Conversion to ${nextStage}`, value: ( metrics.rate * 100 ).toFixed( 1 ) + '%', tooltip: `Percentage of prospects from the past ${window} days that moved to ${nextStage}`, icon: <FaChartLine style={{ color: '#ff7a59', marginRight: 8 }} /> },
                { label: 'Avg Time to Convert', value: ( metrics.avgTimeToConvert ).toFixed( 1 ) + ' days', tooltip: `Average time it took to successfully convert a prospect to ${nextStage} (past ${window} days)`, icon: <FaCalendarAlt style={{ color: '#ff7a59', marginRight: 8 }} /> },
                { label: 'Projected Conversions', value: projectedConversions, tooltip: `Expected conversion range based on a ${( metrics.rate * 100 ).toFixed( 1 )}% historical conversion rate (+/- ${( variance * 100 ).toFixed( 1 )}%)`, icon: <FaMagic style={{ color: '#ff7a59', marginRight: 8 }} /> }
            ] );
            // setRiskMetrics( [
            //     { label: 'Stuck Prospects', value: stuckProspects, tooltip: 'Number of prospects that have been in this stage for more than 30 days', icon: <FaExclamationTriangle style={{ color: '#ff7a59', marginRight: 8 }} /> }
            // ] );
        } else {
            // Reset metrics when no prospects
            setPipelineMetrics( [
                { label: 'Current Prospects', value: 0, tooltip: 'Current # of Prospects', icon: <FaUserFriends style={{ color: '#ff7a59', marginRight: 8 }} /> },
                { label: 'Avg Time as Prospect', value: 0, tooltip: 'Average number of days prospects have been in this stage', icon: <FaClock style={{ color: '#ff7a59', marginRight: 8 }} /> }
            ] );
            setConversionMetrics( [
                { label: 'Successful Conversion %', value: 0, tooltip: 'Percentage of prospects that moved to PreQual/PreApproved over the past 180 days', icon: <FaChartLine style={{ color: '#ff7a59', marginRight: 8 }} /> },
                { label: 'Avg Time to Convert', value: 0, tooltip: 'Average time it took to convert successful prospects (past 180 days)', icon: <FaCalendarAlt style={{ color: '#ff7a59', marginRight: 8 }} /> },
                { label: 'Projected Conversions', value: '0-0', tooltip: `Expected conversion range based on a X% historical conversion rate (+/- ${Math.round( variance * 100 )}%)`, icon: <FaMagic style={{ color: '#ff7a59', marginRight: 8 }} /> }
            ] );
            // setRiskMetrics( [
            //     { label: 'Stuck Prospects', value: 0, tooltip: 'Number of prospects that have been in this stage for more than 30 days', icon: <FaExclamationTriangle style={{ color: '#ff7a59', marginRight: 8 }} /> }
            // ] );
        }
        console.log( 'done setting segment metrics' );
    }, [ prospects, conversionResults, conversionView, variance ] );

    useEffect( () => {
        if ( loans ) {
            const bucket = [];
            
            Object.keys( loans ).forEach( lid => {
                const l = loans[lid];
                if ( !viewing.includes( l.aid ) ) {
                    return;
                }
                if ( l.prospectDate ) {
                    bucket.push( l );
                }
            } );

            const windows = [ 90, 180, 270 ];
            const today = new Date();
            const results = {
                prex: {},
                funded: {}
            };
            for ( const window of windows ) {
                const start = new Date( today );
                start.setDate( start.getDate() - window );
                start.setHours( 0, 0, 0 );

                let totalProspects = 0;
                let prexSuccesses = 0;
                let fundingSuccesses = 0;
                let prexDurations = [];
                let fundingDurations = [];

                for ( const l of bucket ) {
                    const pd = new Date( l.prospectDate );
                    if ( pd < start ) {
                        continue;
                    }

                    totalProspects++;

                    if ( l.pqDate || l.paDate ) {
                        prexSuccesses++;
                        const duration = new Date( l.pqDate || l.paDate ) - pd;
                        prexDurations.push( duration );
                    }

                    if ( l.fundedDate ) {
                        fundingSuccesses++;
                        const duration = new Date( l.fundedDate ) - pd;
                        fundingDurations.push( duration );
                    }
                }

                results.prex[window] = {
                    total: totalProspects,
                    successful: prexSuccesses,
                    rate: prexSuccesses / totalProspects || 0,
                    avgTimeToConvert: prexDurations.length ? prexDurations.reduce( ( a, b ) => a + b, 0 ) / prexDurations.length / ( 1000 * 60 * 60 * 24 ) : 0,
                };

                results.funded[window] = {
                    total: totalProspects,
                    successful: fundingSuccesses,
                    rate: fundingSuccesses / totalProspects || 0,
                    avgTimeToConvert: fundingDurations.length ? fundingDurations.reduce( ( a, b ) => a + b, 0 ) / fundingDurations.length / ( 1000 * 60 * 60 * 24 ) : 0,
                };
            }
            console.log( 'results', results );
            setConversionResults( results );
        }
    }, [ loans, viewing ] );

    useEffect( () => {
        console.log( 'handling location query' );
        if ( location.search !== q ) {
            setGridReady( false );
            setFilterModel( { items: [] } );
            setClassLogic( '' );
            setQ( location.search );
        }
    }, [ location.search, q ] ); 

    useEffect( () => {
        console.log( 'setting stack values' );
        if ( stack ) {
            if ( stack.dialer && stack.dialer.type === 'PhoneBurner' ) {
                setHasPhoneBurner( true );
            }
            if ( stack.sms && stack.sms ) {
                setHasTxting( true );
            }
        }
    }, [ stack ] );
    
    return (
        <Container fluid className='px-0' style={ { height: '100%' } }>
            <Row className='tf-page-container' style={ { height: `calc(100vh - ${containerBuffer}px)` } } ref={containerRef}>
                <Col className='p-0' style={ { height: '100%' } }>
                    <Card style={ { height: '100%' } }>
                        <Card.Body className='py-0'>
                            <Card.Title className='pt-1' ref={titleRef}>
                                <Row>
                                    <Col>
                                        <VscFolderActive />
                                        <span className='ps-2 fw-bold fs-6'>Prospects</span>
                                    </Col>
                                </Row>
                            </Card.Title>
                            <Card.Subtitle className='py-3' ref={numbersRef}>
                                <Row className='text-center'>
                                    <Col>
                                        <Box display="flex" gap={2} justifyContent="space-evenly" sx={ { flexDirection: { xs: 'column', md: 'row' } } }>
                                            <Card variant="outlined" style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', px: 2 }}>
                                            {
                                                pipelineMetrics.map( ( metric, idx ) => (
                                                    <TableMetric key={`pipelineMetric-${idx}`} metric={metric} idx={idx} showDivider={ idx < ( pipelineMetrics.length - 1 ) } />
                                                ) )
                                            }
                                            </Card>
                                            <Card variant="outlined" style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', px: 2, position: 'relative', minHeight: 95 }}>
                                                <Box position="absolute" top={4} right={8}>
                                                    <FormControlLabel
                                                        control={
                                                            <Switch
                                                                size="small"
                                                                checked={conversionView === 'funded'}
                                                                onChange={(e) => setConversionView(e.target.checked ? 'funded' : 'preapproval')}
                                                                color="primary"
                                                            />
                                                        }
                                                        label="Funded"
                                                        labelPlacement="start"
                                                        sx={{ m: 0, typography: 'caption', color: 'text.secondary', '& .MuiFormControlLabel-label': { fontSize: '0.55rem' } }}
                                                    />
                                                </Box>
                                            {
                                                conversionMetrics.map( ( metric, idx ) => (
                                                    <TableMetric key={`pipelineMetric-${idx}`} metric={metric} idx={idx} showDivider={ idx < ( conversionMetrics.length - 1 ) } />
                                                ) )
                                            }
                                            </Card>
                                            {/* <Card variant="outlined" style={{ border: 0, display: 'flex', flexDirection: 'row', alignItems: 'center', px: 2 }}>
                                            {
                                                riskMetrics.map( ( metric, idx ) => (
                                                    <TableMetric key={`pipelineMetric-${idx}`} metric={metric} idx={idx} showDivider={ idx < ( riskMetrics.length - 1 ) } />
                                                ) )
                                            }
                                            </Card> */}
                                        </Box>
                                    </Col>
                                </Row>
                            </Card.Subtitle>
                            <Row>
                                <Col style={ { display: 'flex', height: `${gridHeight}px`, width: '100%' } }>
                                    <ModalCtx.Provider value={ { openModal, closeModal, setModal } }>
                                        { 
                                            ( gridReady ) ? (
                                                <DataGridPro
                                                    apiRef={gridRef}
                                                    initialState={ { 
                                                        // pinnedColumns: { left: [ GRID_CHECKBOX_SELECTION_COL_DEF.field, 'name' ] }
                                                    } }
                                                    getRowId={ ( r ) => r.lid }
                                                    loading={ loading }
                                                    rows={ prospects }
                                                    columns={ cols }
                                                    density='compact'
                                                    checkboxSelection
                                                    disableSelectionOnClick
                                                    slots={ { 
                                                        toolbar: Toolbar,
                                                        columnMenu: customColumnMenu 
                                                    } }
                                                    slotProps={ { toolbar: {
                                                        selectedRows: selectedRows, 
                                                        handleModal: handleModal, 
                                                        hasTxting: hasTxting, 
                                                        hasPhoneBurner: hasPhoneBurner, 
                                                        canExport: canExport,
                                                        viewing: viewing
                                                    } } }
                                                    onRowSelectionModelChange={ ( ids ) => setSelectedRows( ids ) }
                                                    onColumnWidthChange={ handleColumnWidthChange }
                                                    onColumnOrderChange={ handleColumnOrderChange }
                                                    filterModel={ filterModel }
                                                    onFilterModelChange={ ( newFilterModel ) => setFilterModel( newFilterModel ) }
                                                    getRowClassName={ getRowClassName }
                                                    editMode='row'
                                                    onStateChange={ updateKPIs }
                                                />
                                            ) : (
                                                null
                                            )
                                        }
                                    </ModalCtx.Provider>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
            <ToastContainer autoClose={3000} />
            <Modal open={show} onClose={closeModal}>
                <Fragment>{modal}</Fragment>
            </Modal>
        </Container>
    )
}

const mapProps = ( state ) => ( {
    orgId: state.user.orgId,
    aid: state.user.aid,
    uid: state.user.email,
    user: state.user,
    grids: state.user.meta.datagrids,
    viewing: state.user.viewing,
    canExport: state.user.canExport,
    stack: state.user.stack,
    loans: state.loans.byId,
    contacts: state.contacts.byId,
    tasks: state.tasks.byId,
    notes: state.notes.byId,
    lists: state.lists.byId,
    status: state.user.meta.loan.picklist.status
} );
  
const mapDispatch = ( dispatch ) => ( {
    setDatagridWidth: dispatch.user.setDatagridWidth,
    setDatagridOrder: dispatch.user.setDatagridOrder
} );
  
export default connect( mapProps, mapDispatch )( Prospects );